import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import axios, { AxiosResponseTransformer } from 'axios'
import { Entities } from 'src/enums'
import { Contractor, ContractorEditingV2, UploadPhotoResult } from 'src/api'
import { ValuesToResize } from 'src/config'
import { useApiInstance } from './useApiInstance'
import { useSignInRedirect } from '../ui'

interface RequestUpload extends ContractorEditingV2 {
  photos?: Array<any> | null
}

interface RequestParams {
  id: number;
  options?: Omit<
    UseMutationOptions<Contractor, Error, RequestUpload>,
    'mutationKey' | 'mutationFn'
  >;
}

export const useEditContractorRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()
  const redirect = useSignInRedirect()

  return useMutation<Contractor, Error, RequestUpload>(
    [Entities.Contractors, 'edit', id],
    async (payload: RequestUpload) => {
      const { photos, ...editPayload } = payload
      if (photos !== undefined && photos !== null) {
        let photoResult: Array<UploadPhotoResult> = []
        try {
          await api.v1MediaPhotoPut(photos, ValuesToResize.contractor, {
            transformResponse: [
              ...(axios.defaults.transformResponse as AxiosResponseTransformer[]),
              ({ error, result, statusCode }) => {
                if (error) {
                  if (statusCode === 401) redirect()
                  throw new Error(error)
                }
                photoResult = result
              },
            ],
          })
        } catch (e) {
          console.log(e)
        }

        if (photoResult !== undefined && photoResult?.length > 0) {
          const uploadedPhoto = photoResult[0].original
          editPayload.photo = uploadedPhoto
        }

        const { data } = await api.v2AdminContractorsContractorIdPut(
          id,
          editPayload,
        )
        return data as Contractor
      }

      const { data } = await api.v2AdminContractorsContractorIdPut(
        id,
        { ...editPayload, photo: photos === null ? { bucket: '', fileName: '' } : undefined },
      )
      return data as Contractor
    },
    options,
  )
}
